<template>
    <v-card class="panelBlock mt-4" v-if="isVisible">
        <status-overlay class="files-and-media-overlay" :action="loadingAction"></status-overlay>
        <v-flex tag="h2" data-qe-id="files_and_media_header"
            >{{ communityCommonConstant.filesAndMedia.TITLE }}
            <v-btn
                icon
                @click="openFilesMediaSeeMore()"
                data-qe-id="files-and-media_edit_btn"
                class="more_option"
                v-if="showEditIcon && !isMobileAppBrowser"
            >
                <i class="fas fa-pencil-alt"></i>
            </v-btn>
        </v-flex>
        <v-layout v-if="isMobileAppBrowser" class="files-media__mobile-msg" data-qe-id="mobile_app_files_and_media">
            {{ communityCommonConstant.filesAndMedia.HYBRID_UI_MESSAGE_FOR_FILES_MEDIA }}
        </v-layout>
        <v-layout row v-else wrap class="files-media" v-for="(element, i) in getFileAndMedia" :key="i">
            <v-flex xs9>
                <v-flex
                    tag="strong"
                    class="pointer"
                    :data-qe-id="`files-and-media_item_${i}_name`"
                    @click="openFilesMediaNavigateToFolder(element)"
                >
                    {{ element.name }}
                </v-flex>
                <v-flex tag="small" :data-qe-id="`files_and_media_item_${i}_last__modified`"
                    >{{ communityCommonConstant.filesAndMedia.LAST_MODIFIED_DATE }}
                    {{ getShortDate(element.lastModifiedDate) }}</v-flex
                >
            </v-flex>
            <v-flex xs3 class="files-media__icon">
                <v-icon
                    large
                    v-if="element.fileSubType === communityCommonConstant.filesAndMedia.FOLDER"
                    :data-qe-id="`files-and-media_item_${i}_folder_btn`"
                    @click="openFilesMediaNavigateToFolder(element)"
                >
                    {{ element.fileSubType }}
                </v-icon>
                <v-flex tag="small" data-qe-id="files_and_media_file_count"> {{ getFileCount(element.id) }}</v-flex>
            </v-flex>
        </v-layout>
        <v-layout v-if="getFileAndMedia && getFileAndMedia.length === 0 && !isMobileAppBrowser">
            <v-flex xs12 text-xs-center pa-5>
                <span data-qe-id="files-and-media_no-media_message">{{
                    communityCommonConstant.filesAndMedia.NO_MEDIA
                }}</span>
            </v-flex>
        </v-layout>
        <v-flex text-xs-right>
            <v-btn
                v-if="showViewAll && !isMobileAppBrowser"
                data-qe-id="files-and-media_view-all_link"
                @click="openFilesMediaSeeMore()"
                class="primary_btn small transparent"
            >
                {{ appCommonConstants.VIEW_ALL }}
            </v-btn>
        </v-flex>
        <v-dialog content-class="medium" v-model="dialogState.open" persistent>
            <filesand-media-list
                :filesAndMediaDataRefreshFlag="filesAndMediaDataRefreshFlag"
                :navigateToFolderOnOpen="navigateToFolderElement"
                @close="closeDialogState"
            >
            </filesand-media-list>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { communityCommonConstant, iconClassNames } from '../communityCommon.constant';
import { storeGetters } from '../../../store/storeGetters.constant';
import { storeAction } from '@/store/storeActions.constant';
import FilesandMediaList from './FilesandMediaList';
import { getShortDate } from '@/common/utils/dateTime';
import { orderBy } from 'lodash';
import { appCommonConstants } from '../../appCommon.constants';
import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
import { myToolsConstants } from '../../Tools/mytools.constant';

export default {
    name: 'FilesAndMedia',
    components: {
        FilesandMediaList,
        StatusOverlay,
    },
    created() {
        this.getFilesAndMedia({ parentId: null, pageNumber: 1, pageSize: 10 });
    },
    data: () => {
        return {
            filesAndMediaDataRefreshFlag: false,
            communityCommonConstant,
            appCommonConstants,
            dialogState: {
                open: false,
            },
            navigateToFolderElement: null,
        };
    },
    methods: {
        ...mapActions({
            getFilesAndMedia: `chapter/${storeAction.getFilesAndMedia}`,
        }),
        getFileCount(id) {
            const itemsCount = this.filesAndMediaList.find((f) => f.id === id).fileCount;
            return itemsCount === 1
                ? `1 ${this.communityCommonConstant.filesAndMedia.ITEM}`
                : `${itemsCount} ${this.communityCommonConstant.filesAndMedia.ITEMS}`;
        },
        openFilesMediaSeeMore(openFolder = false) {
            if (!openFolder) {
                this.navigateToFolderElement = null;
            }
            this.dialogState.open = true;
            this.filesAndMediaDataRefreshFlag = !this.filesAndMediaDataRefreshFlag;
        },
        openFilesMediaNavigateToFolder(element) {
            this.navigateToFolderElement = element;
            this.openFilesMediaSeeMore(true);
        },
        closeDialogState() {
            this.dialogState.open = false;
        },
        getShortDate,
        iconClassNames,
    },
    computed: {
        ...mapState('actionState', ['actions']),
        ...mapGetters({
            filesAndMediaList: `chapter/${storeGetters.filesAndMediaList}`,
            canReorder: `chapter/${storeGetters.canReorder}`,
            canView: `chapter/${storeGetters.canView}`,
            usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
            isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            rootFolderCount: storeGetters.rootFolderCount,
            communityInfo: `chapter/${storeGetters.communityInfo}`,
        }),
        isVisible() {
            return (this.getFileAndMedia && this.getFileAndMedia.length > 0) || this.canView || this.canReorder;
        },
        getFileAndMedia() {
            return orderBy(
                this.filesAndMediaList.filter((o) => o.isRoot),
                'order',
                'asc',
            ).slice(0, 4);
        },
        loadingAction() {
            return this.actions[storeAction.getFilesAndMedia];
        },
        showEditIcon() {
            return this.canReorder || (this.communityInfo &&
                this.communityInfo.communityId === this.$route.params.communityId &&
                this.communityInfo.userAccess && this.communityInfo.userAccess.canEditMyOwnFilesAndMedia);
        },
        isAllNetworks() {
            return (
                this.usersCommunitiesList &&
                this.usersCommunitiesList.some(
                    (o) => o.communityId === this.$route.params.communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE,
                )
            );
        },
        showViewAll() {
            return this.filesAndMediaList && this.filesAndMediaList.filter((o) => o.parentId == null).length > 4;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../common/styles/_colors.scss';
@import '../../../common/styles/_responsive.scss';

.files-and-media-overlay {
    margin-top: 60px;
}

.files-media {
    padding: 15px 0px;
    border-bottom: 1px solid $ypo-medium-gray;
    margin: 0 15px;

    strong {
        font-weight: 400;
        color: $ypo-dark-background-gray;
        font-family: 'Noto Sans';
        font-size: 16px;
        letter-spacing: 0.25px;
        line-height: 18px;
        word-break: break-word;
    }

    small {
        display: block;
        color: $ypo-gray-text;
        font-size: 10px;
        letter-spacing: 0.3px;
        line-height: 10px;
        margin-top: 10px;
    }

    i {
        font-size: 26px;
        color: $ypo_blue;
    }

    &__icon {
        text-align: center;

        small {
            margin-top: 3px;
        }
    }

    &__mobile-msg {
        padding: 15px;
        text-align: left;
    }
}
</style>
